import { LOCALES, PREPR_PAGE_TYPES, ROUTES } from '@constants/constants';
import { Category, InternalLink, Locale } from '@type-declarations/prepr';

export default function getInternalRoute({
  internalLink: { slug, typename, category },
  locale,
  store = false,
}: {
  algolia?: boolean;
  internalLink: InternalLink;
  locale: Locale;
  store?: boolean;
}): string {
  let route = '/'; // returns homepage on default (if no matches)

  switch (typename) {
    case PREPR_PAGE_TYPES.SHARED_LIST_PAGE:
    case PREPR_PAGE_TYPES.NEWS_OVERVIEW_PAGE:
    case PREPR_PAGE_TYPES.EVENT_OVERVIEW_PAGE:
    case PREPR_PAGE_TYPES.ACTIVITY_OVERVIEW_PAGE:
    case PREPR_PAGE_TYPES.LOCATION_OVERVIEW_PAGE:
    case PREPR_PAGE_TYPES.ROUTE_OVERVIEW_PAGE:
    case PREPR_PAGE_TYPES.MAP_PAGE:
    case PREPR_PAGE_TYPES.EXPLORE_PAGE:
      route = ROUTES[typename][locale];
      break;
    case PREPR_PAGE_TYPES.ACTIVITY_PAGE:
      if (store) {
        route = `/store/activities/${slug}`;
      } else {
        route = `${ROUTES.ActivityOverviewPage[locale]}/${slug}`;
      }
      break;
    case PREPR_PAGE_TYPES.NEWS_PAGE:
      if (store) {
        route = `/store/blogs/${slug}`;
      } else {
        route = `${ROUTES.NewsOverviewPage[locale]}/${slug}`;
      }
      break;
    case PREPR_PAGE_TYPES.EVENT_PAGE:
      if (store) {
        route = `/store/events/${slug}`;
      } else {
        route = `${ROUTES.EventOverviewPage[locale]}/${slug}`;
      }
      break;
    case PREPR_PAGE_TYPES.LOCATION_PAGE:
      if (store) {
        route = `/store/locations/${slug}`;
      } else {
        route = `${ROUTES.LocationOverviewPage[locale]}/${slug}`;
      }
      break;
    case PREPR_PAGE_TYPES.ROUTE_PAGE:
      if (store) {
        route = `/store/routes/${slug}`;
      } else {
        route = `${ROUTES.RouteOverviewPage[locale]}/${slug}`;
      }
      break;
    case PREPR_PAGE_TYPES.HOME_PAGE:
      route = `/`;
      break;
    case PREPR_PAGE_TYPES.MAP_PAGE:
      route = '/store/map';
      break;
    case PREPR_PAGE_TYPES.CONTENT_PAGE:
    case PREPR_PAGE_TYPES.LANDING_PAGE:
      if (store) {
        route = `/store/content/${slug}`;
      } else {
        route = `${slug}`;
      }
      break;
    case PREPR_PAGE_TYPES.MAIN_CATEGORY:
      route = `${slug}`;
      break;
    case PREPR_PAGE_TYPES.SUB_CATEGORY:
    case PREPR_PAGE_TYPES.SUB_SUB_CATEGORY: {
      /* Return the translated slug of a category */
      const getCategorySlug = (
        cat?: Category,
      ): { slug?: string } | undefined => {
        if (!cat) return undefined;

        return {
          slug: cat.localizations.find(loc => loc.locale === LOCALES[locale])
            ?.slug,
        };
      };

      /* Array of available category slugs */
      const categories = [
        getCategorySlug(category?.at(0)),
        getCategorySlug(category?.at(0)?.category?.at(0)),
        getCategorySlug(category?.at(0)?.category?.at(0)?.category?.at(0)),
      ]; // [level 1, level 2, level 3]

      if (categories.findIndex(cat => cat && cat.slug === undefined) > -1) {
        console.warn('Not all categories are translated', {
          category,
          locale,
        });
        break;
      }

      route = categories.reduce((acc, cur) => {
        if (!cur?.slug) return acc;

        return `${cur.slug}/${acc}`;
      }, slug!);

      break;
    }
    case PREPR_PAGE_TYPES.ZIGZAG_CAMPAIGN_PAGE: {
      route = `${ROUTES.ZigzagCampaignPage[locale]}`;
      break;
    }
    default:
      console.warn('Page type not recognized', { typename, slug, locale });
  }

  return route;
}
